import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Deans({ 
  accent = "#115e32",
  pageTitle = "Deans | University of Creative Technology Chittagong",
}) {
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);
  const senior = {
    
  };

  const officers = [    
    
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-[#fffdf6] to-white">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-[#B7EAFC] via-[#D6F5FE] to-[#E6FAFE] text-[#014864] py-20 text-center">
        <motion.h1
          initial={{ y: -40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 1 }}
          className="text-4xl md:text-6xl font-extrabold"
        >
         Deans
        </motion.h1>
        <p className="mt-4 text-lg opacity-90">
          
        </p>
      </section>
		
      {/* Senior Officer */}
      <section className="container mx-auto px-6 py-16">
	  {senior.name? (
		<>
			<motion.div
			  initial={{ scale: 0.9, opacity: 0 }}
			  animate={{ scale: 1, opacity: 1 }}
			  transition={{ duration: 1 }}
			  className="bg-white rounded-2xl shadow-lg p-8 flex flex-col md:flex-row items-center gap-8 hover:shadow-xl transition-all duration-300"
			>
			
			
			  <img
				src={`${import.meta.env.VITE_API_SOURCE_URL}${senior.photo}`}
				alt={senior.name}
				className="w-48 h-56 object-cover rounded-xl border-4 border-[#d4af37]"
			  />
			  <div className="flex-1 space-y-3">
				<h2 className="text-2xl font-bold text-gray-800">{senior.name}</h2>
				<p className="text-[#2563eb] font-semibold">{senior.udesignation}</p>
				<p className="text-[#2563eb] font-semibold">{senior.designation}</p>
				<p className="text-gray-600">{senior.office}</p>
				<div className="space-y-1 text-gray-600 text-sm">
				  <p className="flex items-center gap-2"><Phone size={16}/> {senior.mobile}</p>
				  <p className="flex items-center gap-2"><Mail size={16}/> {senior.email}</p>
				  <p className="flex items-center gap-2"><MapPin size={16}/> {senior.address}</p>
				</div>
				<a
				  href={senior.details}
				  className="inline-block mt-4 px-6 py-2 bg-gradient-to-r from-[#d4af37] to-[#2563eb] text-white rounded-lg shadow hover:opacity-90 transition"
				>
				  View Details
				</a>
			  </div>
			</motion.div>
		</>
		):(
		<>
		</>
		)}
      </section>

      {/* Other Officers */}
      <section className="container mx-auto px-6 pb-20">
        <div className="grid md:grid-cols-3 gap-8">
          {officers.map((officer, index) => (
            <motion.div
              key={index}
              initial={{ y: 40, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              className="bg-white rounded-xl shadow-lg p-6 text-center hover:shadow-xl transition-all duration-300"
            >
              <img
                src={`${import.meta.env.VITE_API_SOURCE_URL}${officer.photo}`}
                alt={officer.name}
                className="w-32 h-40 mx-auto rounded-lg object-cover border-2 border-[#2563eb]"
              />
              <h3 className="mt-4 text-xl font-bold text-gray-800">
                {officer.name}
              </h3>
              <p className="text-[#2563eb] text-sm font-semibold">
                {officer.designation}
              </p>
              <p className="text-gray-600 text-sm">{officer.office}</p>
              <div className="mt-3 text-gray-600 text-sm space-y-1">
                <p className="flex items-center justify-center gap-2">
                  <Phone size={14}/> {officer.mobile}
                </p>
                <p className="flex items-center justify-center gap-2">
                  <Mail size={14}/> {officer.email}
                </p>
                <p className="flex items-center justify-center gap-2">
                  <MapPin size={14}/> {officer.address}
                </p>
              </div>
              <a
                href={officer.details}
                className="inline-block mt-4 px-4 py-2 bg-gradient-to-r from-[#2563eb] to-[#d4af37] text-white rounded-lg text-sm hover:opacity-90 transition"
              >
                View Details
              </a>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
}
